import React from "react";

/** The model's one-line reason for a field. */
const ModelNote = ({ text }) =>
  text ? (
    <p className="mt-1 px-1 text-xs italic text-gray-500">{text}</p>
  ) : null;

export default ModelNote;
